import React, {useEffect} from 'react';
import {sortCompareString} from "../../libs/formbm";
import {useSelector} from "react-redux";
import {Col, Form, Row, Table} from "antd";
const tableColumns = [
    {
        title: 'Харажат',
        dataIndex: 'expense',
        width: 200,
        sorter: (a, b) => sortCompareString(a.expense, b.expense)
    },
    {
        title: 'Тўлов суммаси',
        dataIndex: 'sumPay',
        width: 200,
        align: 'right',
        sorter: (a, b) => a.sumPay -  b.sumPay,
        render: (value) => {
            return new Intl.NumberFormat('en-US', { style: 'decimal' }).format(value);
        }
    }
];
const CashAppHistoryDetails = () => {
    const info = useSelector((state) => state.smetaHistoryTab.details);
    const onFinish = (values) => {
        console.log('Success:', values);
    };
    useEffect(()=> {
        console.log('info', info)
    },[info]);
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    return (
        <div style={{padding: '20px'}}>
            <Form
                name="basic"
                style={{
                    width: '100%',
                    rowGap: '15px'
                }}
                initialValues={{
                    remember: false,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="inline"
            >
                <div style={{display: 'flex', flexDirection: 'column', gap: '30px'}}>
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <Form.Item
                                label="ИД"
                                name="id"
                            >
                                {info?.id}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Ҳисоб рақам ИДиси"
                                name="accId"
                            >
                                {info?.accId}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Ҳисоб рақам"
                                name="acc"
                            >
                                {info?.acc}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Филиал"
                                name="filial"
                            >
                                {info?.filial}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Молиявий йил"
                                name="finYear"
                            >
                                {info?.finyear}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Олувчи ҳисоб рақами"
                                name="coAcc"
                            >
                                {info?.coAcc}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Олувчи ИННиси"
                                name="coInn"
                            >
                                {info?.coInn}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Олувчи МФОси"
                                name="coMfo"
                            >
                                {info?.coMfo}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Олувчи номи"
                                name="coName"
                            >
                                {info?.coName}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Валюта"
                                name="currency"
                            >
                                {info?.currency}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Трансит суммаси"
                                name="sumTransit"
                            >
                                {info?.sumTransit}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Тўлов суммаси"
                                name="sumPay"
                            >
                                {info?.sumPay}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Вендор ИД"
                                name="vendorId"
                            >
                                {info?.vendorId}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Мақсад"
                                name="purpose"
                            >
                                {info?.purpose}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Ой"
                                name="month"
                            >
                                {info?.month}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Table  dataSource={info?.points} columns={tableColumns} pagination={true}/>
                </div>
            </Form>
        </div>
    );
};

export default CashAppHistoryDetails;